const isTest = process.env.NODE_ENV === 'development';

export default {
	type: 'client',
	api: {
		version: 'v0.0.1',
	},
	version: 'v1.0.81',
	isTest,
	useSentry: !isTest,
};
